// src/utils/seo.js
// Single source of truth for the public origin. The apex domain redirects to www
// on Vercel, so www is the canonical host everywhere (canonical tags, sitemap, robots).

export const SITE_URL = 'https://www.thecranberrymovement.com';
export const SITE_NAME = 'The Cranberry Movement';

// Absolute canonical URL for a router pathname (no query string, no trailing slash).
export const canonicalFor = (pathname = '/') => {
  const path = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
  return `${SITE_URL}${path}`;
};

export const absoluteUrl = (path = '/') =>
  /^https?:\/\//.test(path) ? path : `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;

// Search engines cut descriptions off at roughly 160 characters; cut at a word instead.
export const metaDescription = (text = '', max = 160) => {
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(' ')).replace(/[\s,;:.!?–-]+$/, '')}…`;
};

// schema.org BreadcrumbList for a trail like [["Recipes", "/recipes"], ["Cranberry Sauce", "/recipes/x"]].
// "Home" is added in front automatically.
export const breadcrumbJsonLd = (trail) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [['Home', '/'], ...trail].map(([name, path], index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name,
    item: canonicalFor(path),
  })),
});
